export default __webpack_public_path__ + "static/media/prezencne-pk-9-button.44bf6571.svg";